
export function formatStatus(status) {
  return pascalCase(status.replace(/-/g, ' '));
}

function pascalCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function sanitize(obj) {
  Object.keys(obj).forEach(key => {
    if (!obj[key]) {
      delete obj[key];
    }
  });

  return obj;
}

export function sanitizeDate(date) {
  return date.replace('T', ' ').slice(0, -5);
}



export function prepareJobCardReports(jobCards) {
  let csvContent = 'data:text/csv;charset=utf-8,';
  const fields = ['Created Date', 'Last Edited Date' ,'Completed Date', 
  'JobCard Number', 'Job Class', 'Job Status', 'Project Name', 'Job Type', 'Customer Name', 
  'Customer Phone', 'Account No', 'Venus No', 'Stand Number', 'Portion',
  'Subdivision', 'Town', 'Street Addres', 'Region', 'Contractor', 'Job Instruction',
  'Technician', 'Contractor Remarks', 'Inspecting Company', 'Inspector', 'Inspector Remarks', 'High Risk', 'High Priority'];
  csvContent += `${fields.join()},\n`;
  jobCards.forEach(jobCard => {
    const dataString = [
      jobCard.createdAt, jobCard.lastEdited, jobCard.completedAt, jobCard.jobCardNumber,jobCard.jobClass,
      jobCard.status, jobCard.project.name, jobCard.type, jobCard.stand.contactPerson, jobCard.stand.contactPhone,
      jobCard.stand.accountNumber, jobCard.stand.venusNumber, jobCard.stand.standNumber, 
      jobCard.stand.portion, jobCard.stand.subdivision, jobCard.stand.town,
      jobCard.stand.physicalAddress, jobCard.region, jobCard.contractorCompany ? jobCard.contractorCompany.comapanyName : 'N/A', jobCard.jobInstruction, 
      jobCard.technician ? `${jobCard.technician.firstName} ${jobCard.technician.lastName}` : 'N/A',
      jobCard.work ? jobCard.work.remarks : 'N/A', 
      jobCard.inspectorCompany ? jobCard.inspectorCompany.comapanyName : 'N/A',
      jobCard.inspector ? `${jobCard.inspector.firstName} ${jobCard.inspector.lastName}` : 'N/A', 
      jobCard.postInspectionWork ? jobCard.postInspectionWork.remarks : 'N/A',
      jobCard.isJobHighRisk ? "Yes" : "No", jobCard.isHighPriority ? "Yes" : "No"
    ]

    const sanitizedDataString  = dataString.map(x => x ? `"${x}"` : "N/A");
    
    const line = sanitizedDataString.join() + '\n'
    csvContent += line;
  });


  const encodedUri = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', 'JobCardsReport.csv');
  document.body.appendChild(link);
  link.click();
}